import Pristine from 'pristinejs';
import { load } from 'recaptcha-v3';

import '../sass/newsletter-signup.scss';

(() => {
    const $newsletterSignups = document.querySelectorAll('.newsletter-signup');

    if (!$newsletterSignups) return;

            const { RECAPTCHA_V3_SITE_KEY } = typeof GLOBALS !== 'undefined' && GLOBALS ? GLOBALS : {};

    $newsletterSignups.forEach($newsletterSignup => {
        const $form = $newsletterSignup.querySelector('.newsletter-signup__newsletter');

        const initFormValidation = () => {
            if (!$form) return;

            const pristine = new Pristine($form);
        
            $form.addEventListener('submit', e => {
                e.preventDefault();

                if ($form.classList.contains('newsletter-signup__newsletter--loading')) {
                    return;
                }

                $form.classList.add('newsletter-signup__newsletter--loading');

                if (!pristine.validate()) {
                    $form.classList.remove('newsletter-signup__newsletter--loading');

                    return;
                }

                const $recaptchaTokenInput = $form.querySelector('.recaptcha-token');

                if (RECAPTCHA_V3_SITE_KEY && $recaptchaTokenInput) {
                    load(RECAPTCHA_V3_SITE_KEY).then((recaptcha) => {
                        recaptcha.execute('contact').then((token) => {
                            $recaptchaTokenInput.value = token;

                            $form.submit();
                        });
                    });
                } else {
                    $form.submit();
                }
            });
        };

        initFormValidation();
    });
})();
